// extracted by mini-css-extract-plugin
module.exports = {"root":"Banner_root__D_ScB","header":"Banner_header__2czq6","body":"Banner_body__3Ls5X"};